import type { PlaceholderSrOnlyProps } from '@fukku/input/types'

import srOnly from '@fukku/styles/src/srOnly.module.css'

export function PlaceholderSrOnly({
	placeholder,
}: Readonly<PlaceholderSrOnlyProps>) {
	if (!placeholder) {
		return null
	}

	return <span className={srOnly.className}>{placeholder}</span>
}
